import { callSelectors, nucleusConstants } from '@lifesize/nucleus';
import { defineMessages } from 'react-intl';
import _get from 'lodash/get';
import buddyIcon from 'assets/images/buddy_128x128.png';
import { logger } from 'utils/logger';
import { setPillNotificationWithTimeout } from 'actions/Notification';
import { messagesSelector } from 'observers/utils/intl';

const addIncoming = [
  nucleusConstants.GALAXY_ACTION_INCOMING_CALL,
  nucleusConstants.GALAXY_ACTION_CALL_WAITING
];

const removeIncoming = [
  nucleusConstants.GALAXY_ACTION_CALL_CONNECTED,
  nucleusConstants.GALAXY_ACTION_INCOMING_CALL_ENDED,
  nucleusConstants.GALAXY_ACTION_ANSWER,
  nucleusConstants.GALAXY_ACTION_IGNORE,
  nucleusConstants.GALAXY_ACTION_CALL_WAITING_RESPONSE
];

const defaultNotificationOptions = {
  icon: buddyIcon,
  timeout: 0, // no timeout
  priority: 100 // highest
};

const messages = defineMessages({
  call: { id: 'notification.call.title', defaultMessage: 'Incoming Call From' },
  presentationStopped: {
    id: 'notification.presentationStopped',
    defaultMessage: 'The moderator has stopped your presentation.'
  }
});

const notificationMessagesSelector = state => messagesSelector(state, messages);

const notifications = [];

const createNotification = async (title, notificationOptions) => {
  if (!Notification) {
    logger.info('This browser does not support desktop notification');
  }
  else if (Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      logger.info('User did not allow notifications.');
      return;
    }
  }
  const notification = new Notification(title, notificationOptions);
  notification.onclick = () => {
    window.focus();
    notification.close();
  };
  return notification;
};

const createCallNotification = async (title, notificationOptions, id) => {
  const notification = await createNotification(title, notificationOptions);
  if (notification) {
    notifications.push({ id, notification });
  }
};

export const removeNotification = (payload) => {
  if (!payload) return;
  const notificationId = _get(payload, 'galaxyCall.callId') || _get(payload, 'callId') || payload;
  const n = notifications.find(
    notification => notification.id === notificationId
  );
  if (n) n.notification.close();
};

const notificationMiddleware = store => next => (action) => {
  next(action);
  const state = store.getState();

  if (action.type === nucleusConstants.GALAXY_ACTION_PRESENTATION_TOKEN_REVOKED) {
    const message = notificationMessagesSelector(state).presentationStopped;
    if (!document.hasFocus()) {
      createNotification(message, defaultNotificationOptions);
    }
    return store.dispatch(setPillNotificationWithTimeout(message));
  }

  if (addIncoming.includes(action.type) && !document.hasFocus()) {
    const incomingCalls = callSelectors.incomingCallsSelector(state);
    const galaxyCallId = call => _get(call, 'galaxyCall.callId', null);
    const call = incomingCalls.find(i =>
      i.id === action.payload.id
      || galaxyCallId(i) === action.payload.callId
    );
    if (!call) return;
    const displayName = call.displayString;
    const title = state.app.i18n.messages[messages.call.id];
    const notificationOptions = {
      ...defaultNotificationOptions,
      body: displayName
    };
    const currentCallId = galaxyCallId(call) || call.id;
    createCallNotification(title, notificationOptions, currentCallId);
  }

  if (removeIncoming.indexOf(action.type) > -1) {
    removeNotification(action.payload);
  }
};

export default notificationMiddleware;
